export const allowedDistance = 100;

export function getAllowedDistance() {
  if (
    window.location.hostname?.includes("enable.qa") ||
    window.location.hostname?.includes("store.oakberryqa.com") ||
    window.location.hostname?.includes("order.exit55.qa")
  )
    return 4;
  if (
    window.location.hostname?.includes("www.somaeveryday.com") ||
    window.location.hostname?.includes("order-soma.ordable.com")
  )
    return 5;
  return allowedDistance;
}
export function distance(lat1, lon1, lat2, lon2) {
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
    return dist;
  }
}

export const getPosition = (
  address,
  branch,
  branch_delivery_charges,
  areas,
  settings
) => {
  if (address.lat && address.lng && address.gpsConfirmed)
    return { lat: address.lat, lng: address.lng };
  if (settings.is_branch_based_ordering) {
    const bdcID = branch.bdc;
    if (bdcID && bdcID !== -1) {
      const bdcObj = branch_delivery_charges.find((bdc) => bdc.id === bdcID);
      if (bdcObj) {
        return {
          lat: parseFloat(bdcObj.area_lat),
          lng: parseFloat(bdcObj.area_lng),
        };
      }
    }
  } else {
    const areaObj = areas.find((area) => area.id === address.area);
    if (areaObj) {
      return {
        lat: parseFloat(areaObj.lat),
        lng: parseFloat(areaObj.lng),
      };
    }
  }
};

export const getArea = (
  address,
  branch,
  branch_delivery_charges,
  areas,
  settings
) => {
  if (settings.is_branch_based_ordering) {
    const bdcID = branch.bdc;
    if (bdcID && bdcID !== -1) {
      const bdcObj = branch_delivery_charges.find((bdc) => bdc.id === bdcID);
      if (bdcObj && bdcObj.area_id) {
        const areaObj = areas.find((a) => a.id === bdcObj.area_id);
        if (areaObj) return areaObj;
      }
    }
  } else {
    const areaObj = areas.find((area) => area.id === address.area);
    if (areaObj) {
      return areaObj;
    }
  }
};

export const getSelectedCountry = (
  address,
  branch,
  branch_delivery_charges,
  areas,
  settings,
  branches
) => {
  if (address.country) return address.country;
  if (branch.bdc) {
    const bdcObj = branch_delivery_charges.find((bdc) => bdc.id === branch.bdc);
    if (bdcObj) return bdcObj.country_id;
  }
  if (branch.branch) {
    const branchObj = branches.find((b) => b.id === branch.branch);
    if (branchObj) return branchObj.country_id;
  }
  if (address.area) {
    const areaObj = areas.find((area) => area.id === address.area);
    if (areaObj) {
      return areaObj.country;
    }
  }
  return null;
};
